/* eslint-disable */
import { Formik } from "formik";
import React, { useState } from "react";
import DropDownInput from "../../../../../Universal/DropDownInput.component";
import FormInput from "../../../../../Universal/FormInput.component";

const SalaryForm = ({ onDispatch }) => {
  const [submittedValues, setSubmittedValues] = useState(null);

  const salarySlabs = ["Grade A+", "Grade A", "Grade B", "Grade C"];
  const monthsList = ["1 month", "3 months", "6 months", "12 months"];
  const paymentModes = ["Bank Transfer", "Cheque", "Cash"];
  const dispatchedBy = ["Admin", "HR", "Finance Team"];
  return (
    <div className="form">
      <Formik
        initialValues={{
          salarySlab: "",
          totalSalary: 25000,
          grossSalary: 20000,
          monthsFor: "",
          paymentMode: "",
          dispatchedBy: "",
        }}
        onSubmit={(values) => {
          console.log("Form Submitted:", values);
          setSubmittedValues(values);
          onDispatch(true);
        }}
      >
        {({ setFieldValue, handleSubmit, touched, errors, setTouched }) => (
          <form onSubmit={handleSubmit} className="salaryDispatchForm">
            <div
              className="salaryDispatchFormInputs"
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "10px",
              }}
            >
              <DropDownInput
                name="salarySlab"
                label="Salary slab"
                setFieldValue={(val) => setFieldValue("salarySlab", val)}
                placeholder="Choose salary slab"
                suggestionList={salarySlabs}
                errors={errors}
                touched={touched}
                setTouched={(name, isTouched) =>
                  setTouched({ [name]: isTouched })
                }
              />
              <FormInput
                label="Total salary (INR)"
                type="text"
                name="totalSalary"
                touched={touched}
                errors={errors}
                placeholder="Total salary"
                disabled={true}
              />
              <FormInput
                label="Gross salary (INR)"
                type="text"
                name="grossSalary"
                touched={touched}
                errors={errors}
                placeholder="Gross salary"
                disabled={true}
              />
              <DropDownInput
                name="monthsFor"
                label="Months for"
                setFieldValue={(val) => setFieldValue("monthsFor", val)}
                placeholder="Choose months"
                suggestionList={monthsList}
                errors={errors}
                touched={touched}
                setTouched={(name, isTouched) =>
                  setTouched({ [name]: isTouched })
                }
              />
              <DropDownInput
                name="paymentMode"
                label="Payment mode"
                setFieldValue={(val) => setFieldValue("paymentMode", val)}
                placeholder="Choose payment mode"
                suggestionList={paymentModes}
                errors={errors}
                touched={touched}
                setTouched={(name, isTouched) =>
                  setTouched({ [name]: isTouched })
                }
              />
              <DropDownInput
                name="dispatchedBy"
                label="Dispatched by"
                setFieldValue={(val) => setFieldValue("dispatchedBy", val)}
                placeholder="Choose e-signatory"
                suggestionList={dispatchedBy}
                errors={errors}
                touched={touched}
                setTouched={(name, isTouched) =>
                  setTouched({ [name]: isTouched })
                }
              />
            </div>
            <button
              type="submit"
              className="dispatchButton actionBtn"
              style={{
                display: "block",
                width: "60%",
                margin: "10px auto 0",
              }}
            >
              Dispatch
            </button>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default SalaryForm;
